<template>
  <div>
    <!-- <v-btn
      x-small
      class="bg-warning"
      @click="$bvModal.show('InfUnitOfMeasurement')"
    >
      <i class="fas fa-question mr-1"></i> AJUDA UNIDADE DE MEDIDA</v-btn
    > -->
    <div
      v-for="(item, key) in unitOfMeasurements"
      :key="key"
      v-show="item.value == unit_of_measurement_value"
      class="row"
    >
      <div class="col-md-12 pt-0 pb-0">
        <code>{{ item.name }}</code> -
        {{ item.inf }}
        <div v-if="item.conversion">
          <code>
            {{ item.conversion }}
          </code>
        </div>
      </div>
    </div>
    <b-modal
      no-close-on-backdrop
      hide-footer
      id="InfUnitOfMeasurement"
      title="INFORMAÇÕES SOBRE UNIDADES DE MEDIDA"
    >
      <div>
        <table class="table table-sm table-striped table-bordered">
          <thead>
            <tr>
              <th>UNIDADE DE MEDIDA</th>
              <th>INFORMAÇÕES</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, key) in unitOfMeasurements" :key="key">
              <td>{{ item.name }}</td>
              <td>
                <div>
                  {{ item.inf }}
                </div>
                <code>
                  {{ item.conversion }}
                </code>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: "InfUnitOfMeasurement",

  data() {
    return {
      unitOfMeasurements: [],
    };
  },

  props: {
    unit_of_measurement_value: { type: [String, Boolean, Number] },
  },

  created() {
    let unitOfMeasurements = [
      {
        name: "ADESIVO TRASNDÉRMICO",
        inf: "Aceita apenas números inteiros.",
        value: "ADESIVO",
      },
      {
        name: "CÁPSULA",
        inf: "Aceita apenas números inteiros.",
        value: "CAPSULA",
      },
      {
        name: "COMPRIMIDO",
        inf: "Aceita números inteiros ou (0,25 = 1/4) ou (0,33 = 1/3) ou (0,5 = 1/2) ou (0,66 = 2/3) ou (0,75 = 3/4).",
        value: "COMPRIMIDO",
      },
      { name: "DOSE", inf: "Aceita apenas números inteiros.", value: "DOSE" },
      {
        name: "DRÁGEA",
        inf: "Aceita números inteiros ou (0,25) ou (0,5) ou (0,75).",
        value: "DRAGEA",
      },
      {
        name: "ENVELOPE",
        inf: "Aceita apenas números inteiros.",
        value: "ENVELOPE",
      },
      {
        name: " FRASCO",
        inf: "Aceita apenas números inteiros.",
        value: "FRASCO",
      },
      {
        name: " GRAMA",
        inf: "Aceita apenas números inteiros.",
        value: "GRAMA",
      },
      {
        name: " ML",
        inf: "Aceita números inteiros ou (0,25) ou (0,5) ou (0,75).",
        conversion: "1 GOTA equivale a 0,05 ML",
        value: "ML",
      },
      {
        name: " PASTILHA",
        inf: "Aceita números inteiros ou (0,25) ou (0,5) ou (0,75)",
        value: "PASTILHA",
      },
      {
        name: " SACHÊ",
        inf: "Aceita apenas números inteiros.",
        value: "SACHE",
      },
      {
        name: "SUPOSITÓRIO",
        inf: "Aceita apenas números inteiros.",
        value: "SUPOSITORIO",
      },
      {
        name: " UNIDADE",
        inf: "Aceita apenas números inteiros.",
        value: "UNIDADE",
      },
      {
        name: " UI/ML",
        inf: "Aceita apenas números inteiros.",
        conversion: "1 UI equivale a 0,01 ML",
        value: "UI",
      },
    ];

    this.unitOfMeasurements = unitOfMeasurements;
  },
};
</script>
